import { figmaColors, staticColors } from '@bos/ui';

export const appStaticColors = {
	...staticColors,
	iconBackground: figmaColors.white,
	accordionBackground: figmaColors.grey1,
	accordionErrorState: figmaColors.red600,
	accordionInfoState: figmaColors.grey2,
	qrCodeWrapper: figmaColors.grey2,
	pageNotFoundBackground: figmaColors.grey4,
	filterSelectItemHoverBackground: figmaColors.turquoise50,
	highlightMatchBackground: figmaColors.turquoise50,
	highlightMatchText: figmaColors.turquoise500,
	clientSearchResultTableHeaderBackground: figmaColors.grey2,
	partnersColorBackground: figmaColors.turquoise500,
};
